import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "@phosphor-icons/react";

const KEY = "gf347_cookie_consent";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(KEY)) {
            const t = setTimeout(() => setVisible(true), 1200);
            return () => clearTimeout(t);
        }
    }, []);

    function accept() {
        localStorage.setItem(KEY, JSON.stringify({ accepted: true, date: new Date().toISOString() }));
        setVisible(false);
    }

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 80, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 80, opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
                    className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-[150] bg-[var(--gf-navy)] text-white shadow-2xl"
                    style={{ boxShadow: "0 20px 60px rgba(11,25,44,0.4)" }}
                    data-testid="cookie-banner"
                >
                    <div className="p-6">
                        <div className="flex items-start gap-3 mb-4">
                            <div className="w-8 h-8 bg-[var(--gf-gold)] flex items-center justify-center flex-shrink-0 font-mono text-xs">347</div>
                            <div>
                                <div className="micro-label text-[var(--gf-gold)] mb-1">— Cookies</div>
                                <h3 className="serif text-lg leading-tight">Este sitio usa cookies necesarias</h3>
                            </div>
                            <button onClick={() => setVisible(false)} className="ml-auto text-white/50 hover:text-white" data-testid="cookie-close">
                                <X size={18} />
                            </button>
                        </div>
                        <p className="text-sm text-white/80 leading-relaxed mb-4">
                            Utilizamos únicamente cookies técnicas imprescindibles para mantener tu sesión.
                            No usamos cookies de publicidad ni analítica.{" "}
                            <Link to="/cookies" className="text-[var(--gf-gold)] hover:underline">
                                Más información
                            </Link>
                            .
                        </p>
                        <button onClick={accept} className="btn-gold w-full justify-center" data-testid="cookie-accept">
                            Entendido
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
